import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import styled from 'styled-components';
import { borderRadius, space } from '@core-ds/primitives';
export var StatusType = {
  SUCCESS: 'success',
  ERROR: 'error'
};
var Status = styled.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   margin: 0;\n   border-width: 1px;\n   border-style: solid;\n   border-radius: ", ";\n   padding: ", " ", ";\n   font-size: 13px;\n\n   ", "\n"])), borderRadius.md, space[3], space[3], function (_ref) {
  var type = _ref.type;

  if (type === StatusType.SUCCESS) {
    return "\n            color: #288c4e;\n            background-color: #ebf8f0;\n            border-color: #99dab2;";
  } else if (type === StatusType.ERROR) {
    return "\n            color: #f02016;\n            background-color: #feeded;\n            border-color: #fbc1be";
  }
});
export default Status;